// extracted by css-extract-rspack-plugin
export default {"asideSection":"asideSection-LjwxyU"};